var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalenderIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.91683 4.19998H10.0835M2.97239 0.75V1.65011M8.91683 0.75V1.65M8.91683 1.65H3.0835C2.117 1.65 1.3335 2.45588 1.3335 3.44999V9.45001C1.3335 10.4441 2.117 11.25 3.0835 11.25H8.91683C9.88333 11.25 10.6668 10.4441 10.6668 9.45001L10.6668 3.44999C10.6668 2.45588 9.88333 1.65 8.91683 1.65ZM4.54183 7.79999L5.41683 8.69999L7.4585 6.6",
    stroke: "#F6A723",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalenderIcon);
export default __webpack_public_path__ + "static/media/CalenderIcon.dd9bbec343dcc5cc848b6b5e3b0b0d8d.svg";
export { ForwardRef as ReactComponent };